import React, { useState } from "react";
import PropTypes from "prop-types";
import SeeMore from "../SeeMore";
import List from "./List";

const INIT_LIMIT = 3;

const NewsList = ({ newsList }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (newsList.length === 0) return null;

  return (
    <>
      <List newsList={isExpanded ? newsList : newsList.slice(0, INIT_LIMIT)} />
      {!isExpanded && newsList.length > INIT_LIMIT && (
        <SeeMore onClick={() => setIsExpanded(true)} />
      )}
    </>
  );
};

NewsList.propTypes = {
  newsList: PropTypes.array,
};

export default NewsList;
